export default __webpack_public_path__ + "565634b11c595882aa1e8b8e50de7544.glb";